module.exports = __webpack_public_path__ + "img/messages.1080d4cc.svg";